import { FC } from 'react';

import { Button, InputWithSearchIcon } from 'common/components';

import { ACTION_ITEMS } from 'common/config/action.config';

import './VariantsHeader.scss';

type VariantsHeaderProps = {
    searchVal: string;
    onSearchChangeHandler: (e: any) => void;
    onQuitMapping: () => void;
};

const VariantsHeader: FC<VariantsHeaderProps> = ({
    searchVal,
    onSearchChangeHandler,
    onQuitMapping
}: VariantsHeaderProps) => {
    return (
        <div className="variants-header-container">
            <div className={`variants-header ${'header-default'}`}>{'Map to variants'}</div>
            <div className="header-right">
                <InputWithSearchIcon
                    placeholder={ACTION_ITEMS.SEARCH_BUTTON}
                    value={searchVal}
                    className="search-input"
                    onChange={onSearchChangeHandler}></InputWithSearchIcon>

                <Button variant="secondary" className="transparent-bg" onClick={onQuitMapping}>
                    {ACTION_ITEMS.QUIT_MAPPING}
                </Button>
            </div>
        </div>
    );
};

export default VariantsHeader;
